import React, { useContext, useState, useEffect } from 'react';
import toast from 'react-hot-toast';

import { DataContext } from '../../../init/getData';

import { Col, Form, Row, DropdownButton, Dropdown, InputGroup, Card } from 'react-bootstrap';
import { Space, Input, Tag, Button, Spin, Checkbox, Image, Upload } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import Modal from 'react-bootstrap/Modal';

import { FiEdit } from "react-icons/fi";
import { FcUndo, FcRefresh, FcFlowChart, FcRules } from "react-icons/fc";
import { BiSolidTrash, BiExport } from "react-icons/bi";
import { IoBarcodeOutline } from "react-icons/io5";
import { FcKindle, FcCancel, FcPlus } from "react-icons/fc";
import { FaCheck } from "react-icons/fa";
import { HiMinusCircle } from "react-icons/hi";

import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import Loader from '../../../components/loader/loader';

import { numberFormatter, totalFormatter, decimalFormatter } from '../../../components/formatters/numberFormatter';

const SimpleDetails = (props) => {

    const { simpleProduct, setSimpleProduct } = props;

    const { api, userData, settingData, categoryData, vatGroupData, selectedCompany, accountData,
        productData, refData, branchData, seasonData, brandData } = useContext(DataContext);


    const userId = userData.id;
    const userName = userData.name;
    const userRole = userData.role.name;
    const createdBy = parseInt(userData.id);

    const { showModal, toggleModal, table, title, refreshTable, size, footer, idRow, type } = props;
    const [loadingEffect, setLoadingEffect] = useState(false);
    const [isSpinning, setIsSpinning] = useState(false);
    const [isLoading, setIsLoading] = useState(true);


    const [previewOpen, setPreviewOpen] = useState(false);
    const [previewImage, setPreviewImage] = useState('');
    const [fileList, setFileList] = useState([]);

    const [brand, setBrand] = useState([]);
    const [season, setSeason] = useState([]);

    // Account Options
    const accountOptions = accountData?.map(item => ({
        value: item.id,
        label: `${item.chartId}.${item.accountId} ${item.name}`,
        name: item.name,
    }));

    // Load and filter account options
    const loadAccountOptions = (inputValue, callback) => {
        const filteredOptions = inputValue ? accountOptions.filter(option =>
            option.label.toLowerCase().includes(inputValue.toLowerCase())) : [];

        filteredOptions.push({ value: null, label: 'no supplier' });
        callback(filteredOptions);
    };


    // Brand Options
    const brandOptions = brandData.map(item => ({
        value: item.id,
        label: item.name,
    }));


    // Season Options
    const seasonOptions = seasonData.map(item => ({
        value: item.id,
        label: item.name,
    }));


    // category Options
    const categoryOptions = categoryData?.map(item => ({
        value: item.id,
        label: item.name,
    }));

    // vatGroup Options
    const vatGroupOptions = vatGroupData?.map(item => ({
        value: item.id,
        label: item.name,
    }));



    // Generic handler for input changes
    const handleInputChange = (e, type) => {
        let { name, value } = e.target;
        setSimpleProduct((prev) => ({
            ...prev,
            [name]: value,
        }));
    };


    const handleChange = async ({ fileList: newFileList }) => {
        // Convert each uploaded file to base64
        const updatedFileList = await Promise.all(
            newFileList.map(async (file) => {
                if (!file.url && !file.preview) {
                    const base64Data = await getBase64(file.originFileObj);
                    return {
                        ...file,
                        url: base64Data,  // Store the base64 data
                    };
                }
                return file;
            })
        );

        // Update the fileList state
        setFileList(updatedFileList);

        // Extract image URLs (base64 strings) from updated file list
        const imageUrls = updatedFileList.map(file => file.url);

        // Update the simpleProduct state with image URLs
        setSimpleProduct((prevProduct) => ({
            ...prevProduct,
            images: imageUrls, // Store the images as base64 strings
        }));
    };

    const getBase64 = (file) =>
        new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
        });

    const uploadButton = (
        <button
            style={{ border: 0, background: 'none', }}
            type="button" >
            <PlusOutlined />
            <div style={{ marginTop: 8 }} >
                Upload
            </div>
        </button>
    );


    const handlePreview = async (file) => {
        if (!file.url && !file.preview) {
            file.preview = await getBase64(file.originFileObj);
        }
        setPreviewImage(file.url || file.preview);
        setPreviewOpen(true);
    };


    // handle select change
    const handleSelectChange = (selectedOption, name) => {
        setSimpleProduct((prev) => ({
            ...prev,
            [name]: selectedOption.value,
        }));
    };



    return (

        <div>


            <Row className="mb-3">

                {/* Brand  */}
                <Form.Group as={Col}>
                    <Form.Label>Brand</Form.Label>
                    <Select
                        style={{ width: '100px' }}
                        options={brandOptions}
                        isSearchable={true}
                        placeholder="Select"
                        value={brandOptions?.find(option => option.value === simpleProduct.brandId) || []}
                        onChange={e => handleSelectChange(e, 'brandId')}

                    />
                </Form.Group>


                {/* Season  */}

                <Form.Group as={Col}>
                    <Form.Label>Season</Form.Label>
                    <Select
                        style={{ width: '100px' }}
                        options={seasonOptions.filter(option => option.value !== null)}
                        isSearchable={true}
                        placeholder="Select"
                        value={season}
                        onChange={e => handleSelectChange(e, 'seasonId')}

                    />
                </Form.Group>



            </Row>

            <Row className="mb-3">

                {/* width */}
                <Form.Group as={Col}>
                    <Form.Label>Width</Form.Label>
                    <Form.Control type="text" step="any" name='width'
                        value={simpleProduct?.width}
                        onChange={handleInputChange}
                         />
                </Form.Group>

                {/* length */}
                <Form.Group as={Col}>
                    <Form.Label>Length</Form.Label>
                    <Form.Control type="text" step="any" name='length'
                        value={simpleProduct?.length}
                        onChange={handleInputChange}
                         />
                </Form.Group>



            </Row>

            <Row className="mb-3">

                {/* Height */}
                <Form.Group as={Col}>
                    <Form.Label>Height</Form.Label>
                    <Form.Control type="text" step="any" name='height'
                        value={simpleProduct?.height}
                        onChange={handleInputChange}
                         />
                </Form.Group>

                {/* diameter */}
                <Form.Group as={Col}>
                    <Form.Label>Diameter</Form.Label>
                    <Form.Control type="number" step="any" name='diameter'
                        value={simpleProduct?.diameter}
                        onChange={handleInputChange}
                         />
                </Form.Group>
            </Row>

            <Row className="mb-3">

                {/* Size */}
                <Form.Group as={Col}>
                    <Form.Label>Size</Form.Label>
                    <Form.Control type="number" step="any" name='size'
                        value={simpleProduct?.size}
                        onChange={handleInputChange}
                         />
                </Form.Group>

                {/* expiryDate */}
                <Form.Group as={Col} >
                    <Form.Label>Expiry Date</Form.Label>
                    <Form.Control
                        type="date"
                        name="expiryDate"
                        value={simpleProduct?.expiryDate}
                        onChange={handleInputChange}
                    />
                </Form.Group>
            </Row>

            <Row className="mb-3">

                {/* LowInStock */}
                <Form.Group as={Col}>
                    <Form.Label> LowInStock <span style={{ color: 'red' }}> *</span></Form.Label>
                    <Form.Control type="number" step="any" name='lowInStock'
                        value={simpleProduct?.lowInStock ?? 0}
                        onChange={handleInputChange}
                        />
                </Form.Group>

                <Form.Group as={Col}>
                    <Form.Label htmlFor="exampleColorInput">Box Color</Form.Label>
                    <Form.Control
                        type="color"
                        name="color"
                        title="Choose your color"
                        value={simpleProduct?.color}
                        onChange={handleInputChange}
                    />
                </Form.Group>

                <Form.Group as={Col}>
                    <Upload
                        action=""
                        listType="picture-card"
                        fileList={fileList}
                        onPreview={handlePreview}
                        onChange={handleChange}
                        style={{ display: 'inline-block' }} // Center the Upload button
                    >
                        {fileList.length >= 8 ? null : uploadButton}
                    </Upload>

                    {previewImage && (
                        <Image
                            wrapperStyle={{
                                display: 'none',
                            }}
                            preview={{
                                visible: previewOpen,
                                onVisibleChange: (visible) => setPreviewOpen(visible),
                                afterOpenChange: (visible) => !visible && setPreviewImage(''),
                            }}
                            src={previewImage}
                        />
                    )}
                </Form.Group>


            </Row>



        </div>

    )
}


export default SimpleDetails;